export enum KnowledgeBaseStatus {
  Failed = -1,
  NotDefined = 0,
  DefinedNoKB = 1,
  KBInProcess = 2,
  KBReady = 3,
}

export const knowledgeBaseStatusKey = (status?: number | null): string => {
  switch (status) {
    case KnowledgeBaseStatus.Failed:
      return "failed";
    case KnowledgeBaseStatus.NotDefined:
      return "notDefined";
    case KnowledgeBaseStatus.DefinedNoKB:
      return "definedNoKB";
    case KnowledgeBaseStatus.KBInProcess:
      return "inProcess";
    case KnowledgeBaseStatus.KBReady:
      return "ready";
    default:
      return "unknown";
  }
};

export const knowledgeBaseBadgeClasses = (status?: number | null): string => {
  switch (status) {
    case KnowledgeBaseStatus.Failed:
      return "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300";
    case KnowledgeBaseStatus.NotDefined:
      return "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300";
    case KnowledgeBaseStatus.DefinedNoKB:
      return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300";
    case KnowledgeBaseStatus.KBInProcess:
      return "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300";
    case KnowledgeBaseStatus.KBReady:
      return "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300";
    default:
      return "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300";
  }
};

// Shared with the AI agent create dialog and the config tab so both offer the
// exact same options the gateway accepts.
export const LLM_OPTIONS = [
  { value: "gpt-4", label: "GPT-4" },
  { value: "claude-3", label: "Claude" },
];

export const AI_AGENT_TONES = [
  { value: "polite", labelKey: "companySetting:aiAgent.create.tonePolite" },
  { value: "professional", labelKey: "companySetting:aiAgent.create.toneProfessional" },
  { value: "friendly", labelKey: "companySetting:aiAgent.create.toneFriendly" },
];

export const CHAT_HISTORY_UNITS = [
  { value: "day", labelKey: "companySetting:aiAgent.create.unitDay" },
  { value: "month", labelKey: "companySetting:aiAgent.create.unitMonth" },
  { value: "year", labelKey: "companySetting:aiAgent.create.unitYear" },
];

// Extensions the knowledge base pipeline can parse.
export const KB_FILE_EXTENSIONS = [".pdf", ".doc", ".docx", ".txt", ".xlsx", ".csv"];
